import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const PRIMARY = '#1ABB9C';

/**
 * Estado vazio reutilizável para seções do dashboard.
 *
 * Props:
 * - icon: node (ícone MUI) centralizado
 * - title: título curto do estado vazio
 * - description: texto auxiliar
 * - actionLabel + onAction: CTA opcional
 * - success: estilo positivo (ícone verde) quando o vazio é algo bom
 */
export default function EmptyState({ icon, title, description, actionLabel, onAction, success = false }) {
    const tone = success ? PRIMARY : '#9ca3af';

    return (
        <Box sx={{ py: 4, px: 2, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
            {icon && (
                <Box
                    aria-hidden="true"
                    sx={{
                        width: 52, height: 52, borderRadius: '50%',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        bgcolor: success ? '#f0fdf9' : '#f3f4f6', color: tone, mb: 0.5,
                    }}
                >
                    {icon}
                </Box>
            )}
            {title && (
                <Typography variant="body2" fontWeight={600} color="text.secondary">
                    {title}
                </Typography>
            )}
            {description && (
                <Typography variant="caption" color="text.secondary" sx={{ maxWidth: 260 }}>
                    {description}
                </Typography>
            )}
            {actionLabel && onAction && (
                <Button
                    onClick={onAction}
                    size="small"
                    variant="outlined"
                    sx={{
                        mt: 1, textTransform: 'none', borderColor: PRIMARY, color: PRIMARY,
                        '&:hover': { borderColor: PRIMARY, bgcolor: '#f0fdf9' },
                    }}
                >
                    {actionLabel}
                </Button>
            )}
        </Box>
    );
}
